import { MODE_WATER } from '@/lib/constants';
import { OptionModel } from '@/lib/models/option/types';
import { OptionModelSequence } from '@/lib/models/segment/types';
import { getOptionApiHasFreightOnlyVehicles } from '@/lib/transformers/option/utils/get-api-option-has-freight-only-vehicles';
import { getApiOptionLineIds } from '@/lib/transformers/option/utils/get-api-option-line-ids';
import { getApiOptionCarrierIds } from '@/lib/transformers/option/utils/get-api-option-primary-carriers';
import { getApiOptionReliability } from '@/lib/transformers/option/utils/get-api-option-reliability';
import { getApiOptionVehicleIds } from '@/lib/transformers/option/utils/get-api-option-vehicle-ids';
import { getApiOptionNotableVias } from '@/lib/transformers/option/utils/get-api-option-via';
import { getOptionEmissions } from '@/lib/transformers/option/utils/get-option-emissions';
import { transformSegment } from '@/lib/transformers/segment';
import { RouteSequenceApiV4Interface, SegmentModeType } from '@/types/api-types';
import { generateId } from '@/utils/helpers';

export const transformOption = ({
  option,
  routeType,
}: {
  option: RouteSequenceApiV4Interface;
  routeType?: SegmentModeType;
}): OptionModel => {
  const transformedSegments = option.segments.map((segment) => transformSegment({ segment })) as OptionModelSequence;
  const optionCarrierIds = getApiOptionCarrierIds(option);
  const hasEndToEndFreighterAvailable = routeType !== MODE_WATER ? getOptionApiHasFreightOnlyVehicles(option) : true;
  const vehicleIds = getApiOptionVehicleIds(option);
  const lineIds = getApiOptionLineIds(option);
  const emissions = getOptionEmissions(transformedSegments);
  const arrivalOtp = getApiOptionReliability(option);
  const viaLocation = getApiOptionNotableVias(option);

  return {
    id: generateId(),
    totalDistanceKm: option.totalDistanceKm,
    totalDurationSeconds: option.totalDurationSeconds,
    frequency: transformedSegments[0].frequency?.perHour,
    hasEndToEndFreighterAvailable,
    numStopsRange: option.numStopsRange,
    numTransfers: option.numTransfers,
    carrierIds: optionCarrierIds,
    segments: transformedSegments,
    via: viaLocation,
    emissions,
    vehicleIds,
    lineIds,
    arrivalOtp,
  };
};
